import React, { useState, useEffect, useRef, useCallback, } from "react";
import { keyPress } from "../../utils/keyPress";
import { FilterWrapper } from "./FilterWrapper";
import { Button } from "../../Button";
import { FormConsumer } from "../../Form";
import { useTranslation } from "../../hooks/useTranslation";
export var FutureInputFilter = function (_a) {
    var label = _a.label, extraClass = _a.extraClass, _b = _a.direction, direction = _b === void 0 ? "right" : _b, children = _a.children, selected = _a.selected, onSubmit = _a.onSubmit, onClear = _a.onClear, id = _a.id;
    var _c = useState(false), isMenuVisible = _c[0], setIsMenuVisible = _c[1];
    var t = useTranslation();
    var elementRef = useRef(null);
    var mouseDownHandler = useCallback(function (ev) {
        if (elementRef.current) {
            if (!elementRef.current.contains(ev.target) &&
                document.body.contains(ev.target)) {
                setIsMenuVisible(false);
            }
        }
    }, []);
    var keyFunctions = useCallback(function (event) {
        if (event.keyCode === keyPress.ESCAPE) {
            setIsMenuVisible(false);
        }
    }, []);
    useEffect(function () {
        /* TODO Make into a Hook */
        if (isMenuVisible) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        document.addEventListener("mousedown", mouseDownHandler);
        return function () {
            if (isMenuVisible) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
            document.removeEventListener("mousedown", mouseDownHandler);
        };
    }, [keyFunctions, mouseDownHandler, isMenuVisible]);
    return (React.createElement("div", { ref: elementRef, id: id },
        React.createElement(FilterWrapper, { visible: isMenuVisible, onChange: function () {
                setIsMenuVisible(!isMenuVisible);
            }, label: label, value: selected },
            React.createElement("div", { className: "affectBar--filter-box affectBar--filter-box-form affectBar--filter-box--".concat(direction, " ").concat(extraClass ? extraClass : "") },
                children,
                React.createElement(FormConsumer, null, function (_a) {
                    var values = _a.values;
                    return (React.createElement("div", { className: "filter-box--buttons" },
                        React.createElement(Button, { onClick: function () {
                                onSubmit();
                                setIsMenuVisible(false);
                            }, label: t("Submit"), type: "primary", id: id && "".concat(id, "__submit") }),
                        React.createElement(Button, { onClick: function () {
                                onClear(values);
                                setIsMenuVisible(false);
                            }, label: t("Clear"), id: id && "".concat(id, "__clear") })));
                })))));
};
